'use client';

import { useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import toast from 'react-hot-toast';
import Link from 'next/link';
import * as m from 'framer-motion/m';
import { useRouter } from 'next/router';

export default function ResetPasswordPage() {
  const router = useRouter();
  const isLithuanian = router.asPath.startsWith('/lt');
  const isUS = router.asPath.startsWith('/us');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleReset = async () => {
    setLoading(true);
    try {
      const origin = typeof window !== 'undefined' ? window.location.origin : '';
      const redirectTo = `${origin}/reset-password/confirm`;
      const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo });
      if (error) throw error;
      toast.success('Reset email sent!');
    } catch (err: any) {
      toast.error(err?.message || 'Failed to send reset email.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <m.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7, delay: 0.1 }}
      className='min-h-screen flex flex-col items-center px-4 pt-20 pb-16 bg-transparent'
    >
      <div className='relative w-full max-w-md mx-auto glass-bg dark:glass-bg rounded-3xl border border-white/20 dark:border-transparent p-6 sm:p-8 shadow-xl'>
        <h2 className='text-2xl sm:text-3xl font-bold text-center mb-6 text-gray-900 dark:text-white'>
          Reset your password
        </h2>
        <input
          type='email'
          placeholder='Your email'
          className='w-full p-3 mb-4 rounded-xl text-sm bg-white/80 dark:bg-black/40 text-gray-900 dark:text-gray-100 placeholder-gray-400 border border-gray-200 dark:border-gray-700/80 focus:outline-none focus:border-primary'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          onClick={handleReset}
          disabled={loading}
          className='w-full bg-black hover:bg-gray-900 dark:hover:bg-[#090909] disabled:opacity-60 text-white font-semibold py-3 rounded-md transition-colors border border-gray-700 disabled:cursor-not-allowed'
        >
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>
        <p className='text-center text-sm text-gray-500 dark:text-gray-400 mt-4'>
          {isLithuanian ? 'Prisimenate slaptažodį?' : 'Remember password?'}{' '}
          <Link href={isLithuanian ? '/lt/prisijungti' : isUS ? '/us/login' : '/login'} className='text-primary hover:underline'>
            {isLithuanian ? 'Prisijunkite' : 'Login'}
          </Link>
        </p>
      </div>
    </m.div>
  );
}
